import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';

@Component({
  selector: 'app-sign-up-address',
  templateUrl: './sign-up-address.component.html',
  styleUrls: ['./sign-up-address.component.scss'],
})
export class SignUpAddressComponent implements OnInit, OnDestroy {
  model: Captain;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
    console.log(this.model);
  }

  ngOnDestroy(): void {}

  save(captain: any) {
    console.log('save');
    console.log(captain);
    this.captainDAO.updateUserCaptain(captain).subscribe((result) => {
      console.log(result);
      this.userDAO.checkBackground(this.model.userId).subscribe(
        (result) => {
          this.router.navigate(['sign-up/select-service']);
        },
        (error) => {
          console.error(error);
        },
      );
    });
  }
}
